import { useEffect, useRef, useState } from 'react';
import './HealthLossFragments.css';
import { usesPlainHealthBars } from './healthBarPresentation';

const percent = (hp, maxHp) =>
  Math.max(0, Math.min(100, (hp / Math.max(1, maxHp)) * 100));

// Animate only the health that was lost. Mounting a saved value never replays it.
const HealthLossFragments = ({ hp, maxHp, reduceMotion = false }) => {
  const plainHealth = usesPlainHealthBars();
  const previous = useRef(hp);
  const sequence = useRef(0);
  const [loss, setLoss] = useState(null);
  useEffect(() => {
    const before = previous.current;
    previous.current = hp;
    if (hp >= before || reduceMotion || plainHealth) {
      setLoss(null);
      return undefined;
    }
    setLoss({
      id: ++sequence.current,
      left: percent(hp, maxHp),
      width: percent(before, maxHp) - percent(hp, maxHp),
    });
    const timer = setTimeout(() => setLoss(null), 850);
    return () => clearTimeout(timer);
  }, [hp, maxHp, reduceMotion, plainHealth]);
  if (!loss || reduceMotion || plainHealth) return null;
  return (
    <div
      key={loss.id}
      className="coreboundHealthLoss"
      aria-hidden="true"
      style={{ left: `${loss.left}%`, width: `${loss.width}%` }}
    >
      {Array.from({ length: 12 }, (_, index) => (
        <i
          key={index}
          style={{
            '--fragment-delay': `${(index % 4) * 35}ms`,
            '--fragment-drift': `${index % 2 ? -14 : 14}px`,
            '--fragment-cut': `${20 + (index % 3) * 18}%`,
          }}
        />
      ))}
    </div>
  );
};

export default HealthLossFragments;
